import { forwardRef } from 'react';
import { useField, useForwardingRef } from '@arc/frontend/util-common';
import { InputTextField } from './InputTextField';
export const InputTextFieldWithControl = forwardRef(function InputTextFieldWithControl({
  name,
  defaultValue,
  onChangeEffect,
  context,
  forcedErrorMessage,
  min,
  max,
  ...other
}, forwardedRef) {
  const {
    field: {
      ref: fieldRef,
      onChange,
      value,
      ...inputProps
    },
    fieldState: {
      invalid
    },
    errorMessage
  } = useField({
    name,
    defaultValue,
    ...context
  });
  const onChangeHandler = e => {
    if (min !== undefined && +e.target.value < +min) {
      e.target.value = min.toString();
    }
    if (max !== undefined && +e.target.value > +max) {
      e.target.value = max.toString();
    }
    onChange(e);
    onChangeEffect?.(e);
  };
  const inputRef = useForwardingRef(null, [forwardedRef, fieldRef]);
  return <InputTextField {...inputProps} value={value ?? ''} onChange={onChangeHandler} inputRef={inputRef} error={forcedErrorMessage ? true : invalid} helperText={forcedErrorMessage ?? errorMessage} {...other} />;
});